var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100 confirmation-page" }, [
    _c(
      "div",
      {
        staticClass: "container-fluid fixed-top w-100 px-0",
        attrs: { id: "nav-info", role: "navigation" }
      },
      [_c("interview-navi", { attrs: { navData: _vm.navData } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          "quote-panel-open": _vm.quotePanelStatus,
          "quote-panel-close": !_vm.quotePanelStatus
        },
        attrs: { role: "main" }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6 pr-2" },
            [
              _vm.showHomeForceBindMsg
                ? _c(
                    "div",
                    [
                      _c("bundle-confirmation-reminder", {
                        attrs: {
                          carrierType: _vm.carrierType,
                          errorMessage: _vm.homeForceBindMsg
                        }
                      })
                    ],
                    1
                  )
                : _vm.getHomeCarrier
                ? _c("home-confirmation")
                : _vm.isHomeEzlynx
                ? _c(
                    "div",
                    [
                      _c("bundle-confirmation-reminder", {
                        attrs: { carrierType: _vm.carrierType }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 pl-2" },
            [
              _vm.getAutoCarrier && _vm.showAutoForceBindMsg
                ? _c(
                    "div",
                    [
                      _c("bundle-confirmation-reminder", {
                        attrs: {
                          carrierType: "Auto",
                          errorMessage: _vm.autoForceBindMsg
                        }
                      })
                    ],
                    1
                  )
                : _vm.getAutoCarrier
                ? _c("auto-confirmation")
                : _vm.isAutoEzlynx
                ? _c(
                    "div",
                    [
                      _c("bundle-confirmation-reminder", {
                        attrs: { carrierType: "Auto" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d448037a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d448037a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/BundleConfirmation.vue
// module id = null
// module chunks = 